const leftNavCls = "_275lzbnrt5";

export { leftNavCls };
import "./_left-nav.style.linaria.module.css";
//# sourceMappingURL=_left-nav.style.js.map
